import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

	userName: any;
	authorityId: any;

	constructor(private router: Router) {
		// constructor
	}

	ngOnInit(): void {
		// on-init
		this.userName = localStorage.getItem('userName');
		this.authorityId = localStorage.getItem('authorityId');
	}

	logoutUser() {
		localStorage.clear();
		this.router.navigateByUrl('/auth/login');
	}

	onAdminClick() {
		this.router.navigateByUrl('/admin');
	}

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/shared/components/navbar/navbar.component.ts